export const columns = [
   {
      headerName: 'Nombre',
      field: 'nombre',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Apellido',
      field: 'apellido',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Teléfono',
      field: 'telefono',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Correo',
      field: 'correo',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Desarrollo',
      field: 'desarrollo',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Oficina',
      field: 'oficina',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Fecha de Creación',
      field: 'createdAt',
      filter: true,
      sortable: true,
      resizable: true,
      valueFormatter: (params) => {
         if (!params.value) return '';
         const date = new Date(params.value);
         return date.toLocaleString('es-MX');
      },
   },
];
